// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"e9e0e347","397":"72ebe6b6"}[chunkId] + ".chunk.js";
};